<template>
    <div>
        <datatable-bulks :ref-table="refTable"></datatable-bulks>
        <datatable-exports :ref-table="refTable"></datatable-exports>
        <datatable-filters
            :ref-table="refTable"
            :ref-map="refMap"
        ></datatable-filters>
    </div>
</template>

<script>
export default {
    props: {
        refTable: {
            type: String,
            default: "",
            required: true
        },
        refMap: {
            type: String,
            default: "",
            required: false
        }
    }
};
</script>
